<template>
  <div class="tooltip container right">
    <div class="arrow"></div>
    <div class="content">
      <div class="row">
        <div class="col">
          <span class="color" :style="{ backgroundColor: color }"></span>
        </div>
        <div class="col">
          <div class="row flex-1">
            <TextBase class="label" :text="label" color="secondary" weight="bold" type="tiny" />
          </div>
          <div class="row flex-1">
            <TextBase class="value" :text="value" type="label" weight="bold" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TextBase from '@/design-system/atoms/TextBase.vue'
type Props = {
  label: string
  color?: string
  value: string
  x: number
  y: number
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.tooltip.container {
  padding: 11px;
  z-index: 1000;
  position: fixed;
  top: v-bind('y + "px"');
  left: v-bind('x + "px"');
  transform: translate(0, -50%);
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.2));
  pointer-events: none;
  transition: transform 0.05s ease-in-out;
  .arrow {
    position: absolute;
    top: 50%;
    left: 0;
    width: 20px; /* Adjust the arrow size as needed */
    height: 11px; /* Adjust the arrow size as needed */
    background-color: #f9f9f9; /* Arrow background color */
    transform: translate(0, -50%) rotate(90deg);
    clip-path: path(
      'M8.46356 10.1563C9.26315 11.1158 10.7369 11.1158 11.5364 10.1563L20 3.49691e-06L2.09815e-06 0L8.46356 10.1563Z'
    );
  }

  .content {
    background-color: #f9f9f9;
    border-radius: 4px;
    padding: 12px 16px;
  }

  .color {
    width: 3px;
    height: 24px;
    display: block;
    margin-right: 16px;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    .flex-1 {
      flex: 1;
    }

    .col {
      flex-direction: column;
      display: flex;
    }
  }
}
</style>
